import { render, staticRenderFns } from "./CreatePatrocinador.vue?vue&type=template&id=7fe30fd2"
import script from "./CreatePatrocinador.vue?vue&type=script&lang=js"
export * from "./CreatePatrocinador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports